package shared.models

data class LegalSection(
    val heading: String,
    val body: String = "",
    val bulletPoints: List<String> = emptyList(),
    val subSections: List<LegalSection> = emptyList()
)

data class LegalPageContent(
    val title: String,
    val lastUpdated: String,
    val sections: List<LegalSection>,
    val pageSeo: PageSEO
)
